import type { CommandCenterConfig } from './CommandCenterTypes';

export const defaultCommandCenterConfig: CommandCenterConfig = {
  searchDebounceMs: 220,
  minimumSpinnerMs: 360,
  minQueryLength: 2,
  maxResults: 24,
};
